<style lang="less">
@import "./login.less";
</style>

<template>

<div class='login_new'>
  <vue-particles
          class="login-bg"
        color="#39AFFD"
        :particleOpacity="0.7"
        :particlesNumber="100"
        shapeType="circle"
        :particleSize="4"
        linesColor="#8DD1FE"
        :linesWidth="1"
          :lineLinked="true"
          :lineOpacity="0.4"
          :linesDistance="150"
          :moveSpeed="3"
          :hoverEffect="true"
          hoverMode="grab"
          :clickEffect="true"
          clickMode="push"
          >
          </vue-particles>
          <div class="Box">
      <form action="">
        <h3>锦泽人才智能求职系统</h3>
        <p class="desc">WELCOME LOGIN</p>
<p  class="lf">
        <login-form :secoundAuth=secoundAuth @on-success-valid="handleSubmit"></login-form>
         </p>
        <p class="no">
          <span></span>
          <span @click="regsubmit">没有账号？立即注册</span>
        </p>
      </form>
          </div>
  <Modal v-model="regmodalVisible"  title="用户注册" :loading=true :footer-hide=true :mask-closable=false>
                            <register-form :mail="mail" :username='username' ></register-form>
                    </Modal>
  <div class="icp">{{`© ${year} ` }}<a href="http://beian.miit.gov.cn/" target="_blank">{{ record }}</a></div>
    </div>
<!--  <div class="login">-->
<!--    <div class="login-con">-->
<!--      <Card icon="log-in" title="欢迎登录锦泽人才智能求职系统" :bordered="false">-->
<!--        <div class="form-con">-->
<!--          <login-form :secoundAuth=secoundAuth @on-success-valid="handleSubmit"></login-form>-->
<!--&lt;!&ndash;          <p class="login-tip">支持 本地 e-mail LDAP登录</p>&ndash;&gt;-->
<!--          <Row>-->
<!--                                <Col span="12"> <Button @click="regsubmit" type="text" size="small">注册</Button></Col>-->
<!--                          </Row>-->
<!--        </div>-->
<!--      </Card>-->
<!--    </div>-->
<!--  </div>-->
    <!--<Modal v-model="modalVisible"  :title="modalTitle" :loading=true :footer-hide=true :mask-closable=false>-->
    <!--  <register-form v-if="!mfa" :mail="mail" :username='username' @on-submit-success="handleRegisterSubmit"></register-form>-->
    <!--  <m-f-a  v-else :mfa="mfa" :mail="mail" ></m-f-a>-->
    <!--</Modal>-->
</template>
<script>
import { LoginForm, RegisterForm } from '_c/login-form'
import { mapActions } from 'vuex'

export default {
  components: {
    LoginForm,
    RegisterForm
  },
  data () {
    return {
      year: new Date().getFullYear(), // 一般都是最新的一年
      record: '滇ICP备2024028771号-1', // 备案号
      secoundAuth: false,
      modalVisible: false,
      modalTitle: '',
      mail: '',
      username: '',
      mfa: '',
      regmodalVisible: false
    }
  },

  methods: {
    ...mapActions(['handleLogin', 'handleRegister']),
    handleSubmit ({ username, password, dynamic }) {
      this.handleLogin({ username, password, dynamic }).then(res => {
        if (res.code === 0) {
          this.$Message.success(`${res.msg}`)
          // this.secoundAuth = true
          sessionStorage.setItem('sbid', res.sbid)
          // console.log(sessionStorage.getItem('sbid'))
          // console.log(res.sbid)
          this.$router.push({
            name: this.$config.homeName
          })
        } else if (res.code === 1) {
          // 这里弹出二次认证
          this.secoundAuth = true
          this.$Message.success(`${res.msg}`)
        } else if (res.code === -3) {
          this.mail = res.email ? res.email : username
          this.username = res.username ? res.username : username.split('@')[0]
          this.$Message.success({
            content: `${res.msg}`,
            duration: 5,
            closable: true
          })
          this.modalVisible = true
          this.modalTitle = '注册用户'
          // 邮箱认证通过，请根据邮箱完善用户信息
        } else {
          this.$Message.error({
            content: `${res.msg}`,
            duration: 5,
            closable: true
          })
        }
      })
    },
    regsubmit () {
      this.regmodalVisible = true
    },
    handleRegisterSubmit (data) {
      this.handleRegister(JSON.stringify(data)).then(res => {
        if (res.code === 0) {
          this.modalTitle = '动态密钥，非常重要'
          this.mfa = res.mfa.trim()
        } else {
          this.$Message.error({
            content: `${res.msg}`,
            duration: 3,
            closable: true
          })
          this.$router.push({ name: 'login' })
        }
      })
    },
    IEVersion () {
      var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
      var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
      var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
      var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      if (isIE) {
        var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
        reIE.test(userAgent)
        var fIEVersion = parseFloat(RegExp['$1'])
        if (fIEVersion == 7) {
          return 7
        } else if (fIEVersion == 8) {
          return 8
        } else if (fIEVersion == 9) {
          return 9
        } else if (fIEVersion == 10) {
          return 10
        } else {
          return 6// IE版本<=7
        }
      } else if (isEdge) {
        return 'edge'// edge
      } else if (isIE11) {
        return 11 // IE11
      } else {
        return -1// 不是ie浏览器
      }
    },
    openGoogle () {
      if (this.IEVersion() == -1) {
        return false
      }
      try {
        var osh = new ActiveXObject('WScript.Shell')
        var p_app_path = osh.RegRead('HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\App Paths\\chrome.exe\\')
        var oShell = new ActiveXObject('Shell.Application')
        var website = 'http://**********/' // 项目实际地址
        oShell.ShellExecute(p_app_path, website, '', 'open', '1')
        window.location.href = 'http://********/tips2.html' // 服务器更目录放置的展示页面
      } catch (e) {
        // var ele = document.getElementsByName('error')[0]
        // ele.style.display = 'block'
        window.location.href = 'http://**********/tips.html' // 服务器更目录放置的展示页面
      }
    }
  },
  mounted () {
    this.openGoogle()
  }
}
</script>

<style>
.icp {
position: absolute;
bottom: 0;
right: 0;
margin: 10px 0;
width: 100%;
height: 36px;
white-space: pre;
text-align: center;
color: gray;
z-index: 1000;
}
.icp > a {
  color: gray;
  text-decoration: none;
}
.icp > a:hover {
  color: aqua;
  text-decoration: none;
}
</style>

 <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        height: 100vh;
      }

      .Box {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
      }



      h3 {
        font-size: 28px;
        margin-bottom: 20px;
        letter-spacing: 5px;
        color: #fff;
      }

      

      input::placeholder {
        color: #fff;
      }

      .desc {
        margin: 0px 20px 30px;
        text-align: center;
        font-size: 12px;
        color: #d6d6d6;
      }
      .lf {
        width: 100%;
     
  
      }

      .loginBtn {
        cursor: pointer;
        width: 100%;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #000000;
        background: rgb(255, 255, 255);
        outline: none;
        border: none;
        margin-top: 10px;
        transition: all 0.1s;
      }

      .loginBtn:hover {
        border: #000000 1px solid;
        font-weight: 550;
        letter-spacing: 6px;
      }

      .no {
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        text-align: center;
        font-size: 12px;
        color: #c6c6c6;
      }
      .login_new{
        width: 100%;
        height: 100%;
/*        //color: #cccccc; */
        /*如果想做背景图片 可以给标签一个class 直接添加背景图*/
/*        //position: relative;*/
      }

      .login-bg{
      width: 100%;
        height: 100%;
        background: #3E3E3E;
      }

    </style>
